import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import {Form, Formik} from 'formik';
import {useState} from 'react';
import {useLocation} from 'react-router-dom';
import ShopLogo from '../../../assets/image/shopLogo.svg';
import CustomButton from '../../../components/customButton';
import FormikInput from '../../../components/formikFileds/input';
import useGetStates from '../../../services/hookService/auth/getStates/useGetStates';
import UseSignUp from '../hooks/useSignUp';
import {signUpSchema} from './validationSchema';

// import UseSignUp from '../hooks/useSignUp';

interface ISignUpCommand {
  fullName: string;
  province?: {title: string; id: string};
  city?: {title: string; id: string};
  email?: string;
}

const SignUp = () => {
  const initialValues: ISignUpCommand = {
    fullName: '',
    city: undefined,
    province: undefined,
    email: '',
  };
  const {
    state: {mobile, code},
  } = useLocation();
  const {isLoading, mutate} = UseSignUp();
  const [isSearching, setisSearching] = useState(false);
  const [search, setSearch] = useState('');
  const {statesIran} = useGetStates();
  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-4">
      <div className="flex justify-center w-100">
        <img src={ShopLogo} alt={'ShopLogo'} />
      </div>
      <div className="flex flex-col w-[70%] justify-center gap-2">
        <h1 className="p-0 m-0 text-gray-700 text-md font-Regular">عضویت</h1>
        <p className="p-0 m-0 text-sm text-gray-700 font-Medium">
          لطفا اطلاعات کاربری خود را وارد کنید.
        </p>
      </div>
      <Formik
        onSubmit={async values => {
          mutate({
            name: values.fullName,
            state: Number(values.province?.id),
            city: Number(values.city?.id),
            phone_number: mobile,
            code: code,
            country_code: '98',
            country_name: 'ایران',
            email: values.email,
            app: 'supplier',
          });
        }}
        initialValues={initialValues}
        validationSchema={signUpSchema}
      >
        {({values, setFieldValue, isValid, dirty}) => {
          const filteredProvinces = search.length
            ? [
                ...(statesIran ?? []).filter(item =>
                  item.name.toLowerCase().includes(search.toLowerCase()),
                ),
              ]
            : [...(statesIran ?? [])];
          const filteredCities = values.province
            ? statesIran?.find(
                item => String(item.id) === String(values?.province?.id),
              )?.cities
            : [];

          return (
            <Form className="d-flex w-[65%]  flex-col items-center gap-3 sign-up-custom-css-style">
              <FormikInput
                name="fullName"
                label="نام و نام خانوادگی"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setFieldValue('fullName', e.target.value);
                }}
                required={!values.fullName}
              />
              <FormikInput
                name="email"
                label="ایمیل (اختیاری)"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setFieldValue('email', e.target.value);
                }}
              />
              <div className="relative flex flex-col w-full">
                <div
                  className={classNames(
                    'flex w-full h-[36px] bg-white relative items-center rounded-t-[8px] border-[1px] text-gray-700 ',
                    {
                      'rounded-b-[8px]': !isSearching,
                    },
                    {
                      'border-gray-700':
                        !values.province?.id || !values.city?.id,
                    },
                    {
                      'border-farm-shop-500':
                        values.province?.id && values.city?.id,
                    },
                  )}
                >
                  {values.province?.id && values.city?.id && (
                    <p className="absolute right-5 -top-[9px] flex items-start text-xs text-farm-shop-500 px-1 bg-[#fcfcfc] mb-0">
                      <span>موقعیت مکانی</span>
                    </p>
                  )}
                  {!isSearching && !search.length && (
                    <p className="absolute right-3 top-1/2 -translate-y-1/2 flex items-start text-md text-gray-700 mb-0 gap-0.5">
                      <span>موقعیت مکانی</span>
                      <span className="text-red-500">*</span>
                    </p>
                  )}
                  {isSearching && !search.length && (
                    <div className="absolute flex items-center gap-2 text-gray-700 -translate-y-1/2 right-3 top-1/2 text-md">
                      <SpanIcon className="text-base icon-nameSearch " />
                      <span>جستوجو</span>
                    </div>
                  )}
                  <input
                    value={search}
                    onChange={e => {
                      e.target.value.length !== 0 && setisSearching(true);
                      setSearch(e.target.value);
                    }}
                    className={`w-[90%] h-full border-0  outline-none text-md rounded-r-lg text-gray-900 ${
                      isSearching && !search.length ? 'pl-3 pr-[90px]' : 'px-3'
                    }`}
                  />
                  {isSearching && (
                    <div className="flex items-center h-full gap-2">
                      <button
                        type="button"
                        onClick={() => {
                          setSearch('');
                          setFieldValue('city', undefined);
                          setFieldValue('province', undefined);
                          setisSearching(false);
                        }}
                        className="flex items-center bg-inherit"
                      >
                        <SpanIcon className="icon-nameClose-remove" />
                      </button>
                      <span>|</span>
                    </div>
                  )}
                  <button
                    type="button"
                    className="w-[20%] rounded-l-[8px] h-full flex bg-inherit items-center justify-center"
                    onClick={() => setisSearching(prev => !prev)}
                  >
                    {isSearching ? (
                      <SpanIcon
                        className={`icon-nameArrow---Up-2 ${
                          values.province?.id && values.city?.id
                            ? 'text-farm-shop-500'
                            : ''
                        }`}
                      />
                    ) : (
                      <SpanIcon
                        className={`icon-nameArrow---Down-2-1 ${
                          values.province?.id && values.city?.id
                            ? 'text-farm-shop-500'
                            : ''
                        }`}
                      />
                    )}
                  </button>
                </div>
                <div
                  className={classNames(
                    ' w-full absolute gap-3 px-3 py-3 bg-white  flex-col top-[36px] overflow-y-auto h-[112px] rounded-b-[8px] border-[1px] border-gray-700',
                    {
                      flex: isSearching,
                      hidden: !isSearching,
                    },
                  )}
                >
                  <>
                    {(search.length && !values.province) ||
                    (!search.length && !values.province) ? (
                      filteredProvinces.map(item => (
                        <div
                          key={'filter-province' + item.id}
                          className="flex items-center justify-between w-full px-3 text-gray-700 text-md"
                          onClick={() =>
                            setFieldValue('province', {
                              id: item.id,
                              title: item.name,
                            })
                          }
                        >
                          <span>{item.name}</span>
                          <SpanIcon className="text-base icon-nameArrow---Left-2" />
                        </div>
                      ))
                    ) : (search.length && values.province) ||
                      (!search.length && values.province) ? (
                      <>
                        {filteredCities?.length &&
                          filteredCities.map(item => (
                            <div
                              key={'city' + item.id}
                              className={classNames(
                                'flex justify-between w-full rounded px-3 items-center text-md py-1.5 ',
                                {
                                  'bg-farm-shop-50 border-[1px] border-farm-shop-500 text-farm-shop-500 font-semibold':
                                    String(item.id) === String(values.city?.id),
                                },
                                {
                                  'text-gray-700 font-normal':
                                    String(item.id) !== String(values.city?.id),
                                },
                              )}
                              onClick={() => {
                                setFieldValue('city', {
                                  id: item.id,
                                  title: item.name,
                                });
                                setSearch(
                                  `${values.province?.title} _ ${item.name}`,
                                );
                                setisSearching(false);
                              }}
                            >
                              <span>{item.name}</span>
                              <button
                                className="flex items-center h-full"
                                type="button"
                              >
                                <SpanIcon className="text-base icon-nameClose-remove" />
                              </button>
                            </div>
                          ))}
                      </>
                    ) : null}
                  </>
                </div>
              </div>
              <CustomButton
                disabled={isLoading || !isValid || !dirty}
                type="submit"
                className=" w-full flex items-center justify-center rounded-[8px] text-white h-[32px] bg-farm-shop-500  disabled:bg-gray-700"
                title="عضویت"
                isLoading={isLoading}
              />
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default SignUp;
